import { getToken } from "../../helpers/common";
import * as apiService from "../api";
import * as API_URL from "../../constants/api";


export const getCampaignInformation = async (payload) => {
    try {
        const token = getToken();
        const { campaignUuid } = payload;
        const response = await apiService.get(`${API_URL.SMS_CAMPAIGN}/getInfo/${campaignUuid}`, token);
        return response;
    } catch (err) {
        console.log("Error in getCampaignInformation service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}

export const getCampaignSummary = async (payload) => {
    try {
        const token = getToken();
        const { campaignUuid } = payload;
        const response = await apiService.get(`${API_URL.SMS_CAMPAIGN}/getSummary/${campaignUuid}`, token);
        return response;
    } catch (err) {
        console.log("Error in getCampaignSummary service : ", err);
        return { success: false, message: "Internal Server Error", data: null };
    }
}

export const getCampaignDataIssues = async ({ campaignUuid, page = 1, limit = 10, eventType = 'all', }) => {
    try {
        const token = getToken();
        const payload = { eventType };
        const queryParams = new URLSearchParams({ campaignUuid, page, limit }).toString();
        const result = await apiService.post(`${API_URL.SMS_CAMPAIGN}/getDataIssues?${queryParams}`, payload, token);
        return result;
    } catch (err) {
        return {
            status: false,
            data: {},
            message: err?.message || "Error fetching logs",
        };
    }
};

export const getSmsCampaignValidContacts = async (payload) => {
    try {
        const token = getToken();
        const result = await apiService.post(`${API_URL.SMS_CAMPAIGN}/getSmsCampaignValidContacts`, payload, token);
        return result;
    } catch (err) {
        return {
            status: false,
            data: {},
            message: err?.message || "Error fetching getSmsCampaignValidContacts",
        };
    }
}